import { MoreHorizontalIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { Switch } from '@/components/ui/switch';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

export const TableSkeleton = () => {
  return (
    <div className="space-y-4">
      <div className="flex justify-start">
        <Skeleton className="h-9 w-80 rounded-md bg-background" />
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-80">
              <div className="flex items-center gap-1">
                <Skeleton className="h-4 w-[200px]" />
                <Skeleton className="h-4 w-4" />
              </div>
            </TableHead>
            <TableHead className="w-[120px]">
              <div className="flex items-center gap-1">
                <Skeleton className="h-4 w-[50px]" />
                <Skeleton className="h-4 w-4" />
              </div>
            </TableHead>
            <TableHead className="w-[120px]">
              <div className="flex items-center gap-1">
                <Skeleton className="h-4 w-[50px]" />
                <Skeleton className="h-4 w-4" />
              </div>
            </TableHead>
            <TableHead className="w-[120px]">
              <div className="flex items-center gap-1">
                <Skeleton className="h-4 w-[50px]" />
                <Skeleton className="h-4 w-4" />
              </div>
            </TableHead>
            <TableHead className="w-[100px]">
              <Skeleton className="h-4 w-[50px]" />
            </TableHead>
            <TableHead className="w-[50px]"></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {Array.from({ length: 6 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableRow key={index}>
              <TableCell>
                <Skeleton className="h-4 w-[200px]" />
              </TableCell>
              <TableCell>
                <Skeleton className="h-6 w-20 rounded-full" />
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-2">
                  <Skeleton className="h-8 w-8 rounded-full" />
                  <Skeleton className="h-4 w-4" />
                </div>
              </TableCell>
              <TableCell>
                <Skeleton className="h-4 w-20" />
              </TableCell>
              <TableCell>
                <Switch disabled />
              </TableCell>
              <TableCell>
                <Button variant="ghost-neutral" size="sm" disabled>
                  <MoreHorizontalIcon className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
